import React from 'react'

function Controls({ width, height }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48">
      <g data-name="Safe and secure transactions" transform="translate(0 1)">
        <path fill="none" d="M0 0h48v47H0z" data-name="Path 6" />
        <text fill="#24397a" data-name="" fontFamily="JioMoney" fontSize="47" transform="translate(0 43)">
          <tspan x="0" y="0">
            
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default Controls
